const minString = ['00', '30']
const maxClsss = 11
export function formatDate (date, fmt) {
  if (!date) {
    return ''
  } else if (typeof date === 'string') {
    date = new Date(date)
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str))
    }
  }
  return fmt
}

export function isContinous (e, key) {
  let dates = {} // 创建对象存取类似
  // {'2019-06-01':[],'2019-06-02':[],}
  let keys = e.map(v => v[key].split('T')[0])
  for (let v of keys) {
    dates[v] = []
    for (let w of e) {
      let nmuber = w[key].split('T')
      if (nmuber[0] === v) {
        let numberTansform1 = nmuber[1].split(':')[0]
        let numberTansform2 = nmuber[1].split(':')[1]
        if (numberTansform2 === minString[0]) {
          dates[v].push(parseInt(numberTansform1) * 2)
        }
        if (numberTansform2 === minString[1]) {
          dates[v].push(parseInt(numberTansform1) * 2 + 1)
        }
      }
    }
    let arrs = []
    for (let v in dates) {
      if (dates[v].length >= maxClsss) {
        arrs[v] = []
        arrs[v] = getNewArr(dates[v].sort())
        if (arrs[v].length > 0) {
          return arrs[v].length
        }
      }
    }
  }
}

function padLeftZero (str) {
  return ('00' + str).substr(str.length)
}

function getNewArr (arr) {
  let i
  let j
  let l = arr.length
  let result = []
  for (i = 0; i < l; i++) {
    for (j = i; j < l; j++) {
      if (arr[j] === (arr[i] + (maxClsss - 1))) {
        result.push(arr.slice(i, j + 1))
      }
    }
  }
  return result.filter(item => item.length === maxClsss)
}

Date.prototype.dateClone = function() {  //在DATE原型上 挂载深度克隆方法
  return new Date(this.valueOf());
}

//获取下周一日期
// console.log(getNextDate(-7));
//获取下周日日期
// console.log(getNextDate(-13));
export function getNextDate(n) {
  let now = new Date();
  let year = now.getFullYear();
  let month = now.getMonth() + 1;
  let day = now.getDay(); 
  n = day == 0 ? n + 6 : n + (day - 1)
  now.setDate(now.getDate() - n);
  let date = now.getDate();
  let s = year + "-" + (month < 10 ? ('0' + month) : month) + "-" + (date < 10 ? ('0' + date) : date);
  return s;
}